import { useEffect, useRef, useState } from 'react';
import DaumPostcodeEmbed from 'react-daum-postcode';
import { useLocation } from 'react-router-dom';

import { Modal } from 'shared/ui';
import CheckFailModal from 'legacy/layouts/Modal/CheckFailModal';
import HCPModal from 'legacy/layouts/Modal/HCPModal';
import { encryptText } from 'legacy/lib/jsencrypt';

import { useSendNewPtAddress } from '../model/mutation';

export const Body = () => {
  const [addressData, setAddressData] = useState({ postNo: '', bscAddr: '', dtlAddr: '', bldgCd: '' });
  const [showPostcode, setShowPostcode] = useState(false);
  const { mutate: sendAddress, data: sendResult } = useSendNewPtAddress();
  const {
    state: {
      sucsRedirectURL,
      failRedirectURL,
      failconnRedirectURL,
      comeTo,
      maskPtRrn,
      interfaceCommonYn,
      ...sendAddressParams
    },
  } = useLocation();
  const [checkFailCount, setCheckFailCount] = useState(0);
  const [checkFailConnCount, setCheckFailConnCount] = useState(0);
  const [failMessage, setFailMessage] = useState('');
  const [errorModalData, setErrorModalData] = useState(null);
  const [checkFailModalOpen, setCheckFailModalOpen] = useState(false);
  const [showPtCardModal, setShowPtCardModal] = useState(false);
  const dtlAddrInputRef = useRef(null);
  const addrSectionRef = useRef(null);
  const [isSubmmit, setIsSubmit] = useState(false);

  useEffect(() => {
    if (!sendResult) return;
    const { result, ityy, popUpButtonList } = sendResult.data;

    switch (result) {
      case '0':
        if (comeTo === 'ptcard') {
          setShowPtCardModal(true);
        }
        window.location.replace(decodeURIComponent(sucsRedirectURL));
        break;
      case '1':
        setCheckFailCount(checkFailCount + 1);
        setFailMessage(ityy);
        break;
      case '2':
        setCheckFailConnCount(checkFailConnCount + 1);
        setFailMessage(ityy);
        break;
      case '3':
        setErrorModalData({ mainTitl: ityy, popUpButtonList });
        break;
      default:
        break;
    }
    setIsSubmit(false);
  }, [sendResult]);

  useEffect(() => {
    if (checkFailCount >= 4) {
      window.location.replace(decodeURIComponent(failRedirectURL));
    } else if (checkFailCount && checkFailCount < 4) {
      setCheckFailModalOpen(true);
    }
  }, [checkFailCount]);

  useEffect(() => {
    if (checkFailConnCount >= 2) {
      window.location.replace(decodeURIComponent(failconnRedirectURL));
    } else if (checkFailConnCount && checkFailConnCount < 2) {
      setCheckFailModalOpen(true);
    }
  }, [checkFailConnCount]);

  const handleCloseCheckFailModal = () => {
    setCheckFailModalOpen(false);
  };

  return (
    <>
      <div className='container-wrap non-member btn-fixed'>
        <div className='content-area'>
          {/* title-top */}
          <div className='title-area'>
            <h2 className='header-tit-02'>
              신규 환자 등록을 위해
              <br />
              주소를 입력해주세요
            </h2>
            <span className='sub-tit-01'>걱정마세요. 소중한 주소 정보는 병원에서 안전하게 보관되어요.</span>
          </div>

          {/* content */}
          <div className='main-content-area'>
            <div className='user-box'>
              {/* 가입정보 */}
              <ul className='user-info-list type01'>
                <li>
                  <span className='title'>이름</span>
                  <span className='content'>{sendAddressParams.ptNm}</span>
                </li>
                <li>
                  <span className='title'>주민등록번호</span>
                  <span className='content'>{maskPtRrn}</span>
                </li>
              </ul>
            </div>

            {/* 우편물 받는 곳 */}
            <div className='user-info-address' ref={addrSectionRef}>
              <span className='title'>우편물 받는 곳</span>
              <div className='content'>
                {/* 주소 input */}
                <div className='inp-item-wrap'>
                  <input
                    type='text'
                    placeholder='주소를 검색해주세요'
                    className='inp-text-01'
                    value={addressData.bscAddr && addressData.bscAddr !== 'null' ? addressData.bscAddr : ''}
                    onClick={(e) => {
                      setShowPostcode(true);
                      setTimeout(() => {
                        window.scrollTo(0, window.scrollY + addrSectionRef.current.getBoundingClientRect().top);
                      }, 10);
                    }}
                    readOnly
                  />
                </div>
                {showPostcode && (
                  <div key={showPostcode} className='icon-close-wrap'>
                    <button className='icon-close' onClick={() => setShowPostcode(false)}>
                      닫기
                    </button>

                    <DaumPostcodeEmbed
                      onComplete={({ address, buildingName, zonecode, buildingCode }) => {
                        setAddressData({
                          ...addressData,
                          postNo: zonecode,
                          bscAddr: `${address} ${buildingName}`.trimEnd(),
                          dtlAddr: '',
                          bldgCd: buildingCode,
                        });
                        setShowPostcode(false);
                        dtlAddrInputRef.current.focus();
                      }}
                      submitMode={false}
                    />
                  </div>
                )}
                {/* 상세 주소 input */}
                <div className='inp-item-wrap'>
                  <input
                    type='text'
                    placeholder='상세주소를 입력해주세요'
                    className='inp-text-01'
                    value={addressData.dtlAddr && addressData.dtlAddr !== 'null' ? addressData.dtlAddr : ''}
                    onChange={(e) => setAddressData({ ...addressData, dtlAddr: e.target.value })}
                    ref={dtlAddrInputRef}
                  />
                  <button
                    type='button'
                    className='btn-clear'
                    onClick={() => {
                      setAddressData({ ...addressData, dtlAddr: '' });
                      dtlAddrInputRef.current.value = '';
                    }}
                  >
                    <span
                      className='icon icon_clear2'
                      style={{ display: dtlAddrInputRef?.current?.value?.length === 0 ? 'none' : 'block' }}
                    >
                      입력된 내용 지우기
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* bottom fixed btn */}
          <div className='btm-area gradient-btm'>
            <button
              className={`btn btm-btn-primary ${
                addressData.postNo && addressData.bscAddr && addressData.dtlAddr && addressData.bldgCd
                  ? ''
                  : 'btn-disabled'
              }`}
              onClick={() => {
                if (!isSubmmit) {
                  setIsSubmit(true);
                  (async () => {
                    const { ptNm, ptRrn, hspCd } = sendAddressParams;

                    const params = {
                      ...sendAddressParams,
                      ptNm: await encryptText(ptNm, { hspCd }),
                      ptRrn: await encryptText(ptRrn.replace(/[^0-9*]/g, ''), {
                        hspCd,
                      }),
                    };

                    sendAddress({ ...params, ...addressData, interfaceCommonYn });
                  })();
                }
              }}
              disabled={!(addressData.postNo && addressData.bscAddr && addressData.dtlAddr && addressData.bldgCd)}
            >
              <span className='btn-txt-01'>완료</span>
            </button>
          </div>
        </div>
      </div>
      {showPtCardModal && (
        <Modal
          title='환자 정보 확인 완료'
          contents={
            <>
              환자 정보 확인이 완료되었어요.
              <br />
              발급을 다시 진행해 주세요.
            </>
          }
          close={() => {
            window.location.replace(decodeURIComponent(sucsRedirectURL));
          }}
        />
      )}
      <CheckFailModal open={checkFailModalOpen} onClose={handleCloseCheckFailModal} content={failMessage} />
      {errorModalData && <HCPModal cpModalData={errorModalData} closeCpModal={() => setErrorModalData(null)} />}
    </>
  );
};
